import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { ordersApi, type OrderListParams } from '../api/orders-api';

import { orderKeys } from './order-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function orderListQueryOptions(storeId: string, params: OrderListParams) {
  return queryOptions({
    queryKey: orderKeys.list(storeId, params),
    queryFn: () => ordersApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useOrders(storeId: string, params: OrderListParams) {
  return useQuery(orderListQueryOptions(storeId, params));
}
